<template>
  <div class="gutenberg group">
    <component
      :is="components.get(parseBlockName(block.blockName))"
      v-for="(block, index) in data.innerBlocks"
      :key="index"
      :data="block.blockName.includes('acf/') ? block.attrs.data : block"
    />
  </div>
</template>

<script>
import { parseBlockName } from '@/assets/js/utils';
import components from '@/assets/js/components';

export default {
  name: 'Group',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parseBlockName,
      components,
    };
  },
};
</script>

<style lang="scss" scoped></style>
